import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./CustomTextField.css";

const CustomTextField = ({ label, value, onChange, variant, size, allowedChars, className }) => {
  const [isInvalid, setIsInvalid] = useState(false);
  const [helper, setHelper] = useState("");

  const clearValue = () => onChange({ target: { value: "" } });

  const getRegex = () => {
    if (!allowedChars) return null;
    if (allowedChars instanceof RegExp) {
      const source = allowedChars.source;
      const hasAnchors = source.startsWith("^") && source.endsWith("$");
      return hasAnchors ? allowedChars : new RegExp(`^${source}$`);
    }
    return new RegExp(`^[${allowedChars}]*$`);
  };

  const validate = (val) => {
    const regex = getRegex();
    if (!regex) {
      setIsInvalid(false);
      setHelper("");
      return;
    }
    const valid = regex.test(val);
    setIsInvalid(!valid);
    setHelper(valid ? "" : "Contains invalid characters");
  };

  useEffect(() => {
    validate(value ?? "");
  }, [value, allowedChars]);

  const handleChange = (e) => {
    onChange(e);
    validate(e.target.value ?? "");
  };

  return (
    <TextField
      variant={variant || "outlined"}
      size={size || "small"}
      label={label}
      value={value}
      onChange={handleChange}
      error={isInvalid}
      helperText={isInvalid ? helper : ""}
      InputProps={{
        classes: {
          root: `custom-input-root-inner ${className}`,
          input: "custom-input-element",
        },
        endAdornment: (
          <InputAdornment position="end" className="custom-adornment">
            <IconButton
              size="small"
              onClick={clearValue}
              className={`clear-btn ${value ? "visible" : ""}`}
            >
              <FontAwesomeIcon icon={faTimes} />
            </IconButton>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        classes: { root: "custom-input-label" },
      }}
    />
  );
};

export default CustomTextField;
